(() => {
  /**
   * Animate the background between light and dark states
   */
  class BackgroundAnimator extends PIXI.Container {
    constructor() {
      super();
      // asset names
      this._baseBackgroundDarkName = "bgBaseLandscapeDark";
      this._portraitBaseBackgroundDarkName = "bgBasePortraitDark";
      this._sparksName = "Sparks";

      // asset references
      this._backgroundDarkAsset = null;
      this._sparksAsset = null;

      this._backgroundAnimation = null;
      this._backgroundParticleEmitter = null;
      this.hasLoaded = false;

      this._sparksPosition = {
        landscape: { x: 620, y: 320, scale: 1.2 },
        portrait: { x: 380, y: 535, scale: 1.2 },
      };
    }

    /**
     * Initialise the class
     */
    initialise() {
      messageBus.subscribe("spinner:GameConfigEvent", () => {
        this._onLayoutComplete();
      });
      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Once asset layout has complete then grab the assets
     */
    _onLayoutComplete() {
      const isLandscape = systemData.isLandscape;
      this._setAssets(isLandscape);

      const sparksPosition = isLandscape ? this._sparksPosition.landscape : this._sparksPosition.portrait;
      this._backgroundParticleEmitter = particleManager.createEmitter(
        "backgroundEmbers",
        this.name,
        sparksPosition.x,
        sparksPosition.y,
        false,
        sparksPosition.scale
      );

      this._backgroundParticleEmitter.blendMode = PIXI.BLEND_MODES.ADD;
      this._backgroundParticleEmitter.particleEmitter.emit = true;

      this._animateBackground();
      this.hasLoaded = true;
    }

    /**
     * Handle setting the ssets depending on orientation
     * @param {boolean} isLandscape
     */
    _setAssets(isLandscape) {
      this._backgroundDarkAsset = resourceManager.get(
        `${this.name}:${isLandscape ? this._baseBackgroundDarkName : this._portraitBaseBackgroundDarkName}`
      );
    }

    /**
     * Animate the background
     */
    _animateBackground() {
      this._backgroundAnimation && this._backgroundAnimation.kill();
      this._backgroundAnimation = gsap.fromTo(
        this._backgroundDarkAsset,
        {
          alpha: 0.8,
        },
        {
          alpha: 0,
          duration: 2,
          yoyo: true,
          repeat: -1,
        }
      );
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {
      if (this.hasLoaded) {
        this._setAssets(isLandscape);
        this._animateBackground();

        const sparksPosition = isLandscape ? this._sparksPosition.landscape : this._sparksPosition.portrait;
        this._backgroundParticleEmitter.x = sparksPosition.x;
        this._backgroundParticleEmitter.y = sparksPosition.y;
        this._backgroundParticleEmitter.scale.set(sparksPosition.scale);
      }
    }
  }

  resourceManager.registerObjectType(
    "backgroundAnimator",
    () => new BackgroundAnimator(),
    initialise,
    () => []
  );
})();
